import React from 'react';
import PropTypes from 'prop-types';
import s from './Status.module.scss';
import classNames from 'classnames';

const Status = ({ statusColor = 'Green', statusText, modifier }) => {
    const classes = classNames(
        s.Root,
        s[`Root--${statusColor}`],
        s[`Root--${modifier}`]
    );

    return (
        <div className={classes}>
            {statusText && <span className={s.StatusText}>{statusText}</span>}
            <span className={s.StatusColor}>
                <span className="sr-only">{statusText}</span>
            </span>
        </div>
    );
};

Status.propTypes = {
    statusColor: PropTypes.string.isRequired,
    statusText: PropTypes.string.isRequired,
    showText: PropTypes.bool,
};

export default Status;
